// Libs
import React from 'react';
import moment from 'moment';

// Services & Helpers
import TextHelpers from 'helpers/TextHelpers';
import NoteService from 'services/NoteService';
import GlobalStateService from 'services/GlobalStateService';

// Components
import Loader from 'components/common/Loader';
import EditNoteModal from 'components/notes/EditNoteModal';
import AllNotesModal from 'components/notes/AllNotesModal';

//-------------------------------------------------------------------------------------------------------------------

class NotesTable extends React.Component {

    constructor(props) {
        super(props);

        this.editNoteModalRef = React.createRef();
        this.allNotesModalRef = React.createRef();

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const notes = await NoteService.list(this.props);
        this.setState({
            notes,
            isLoading: false
        }, () => {
            if (this.props.onLoad) {
                this.props.onLoad(notes);
            }
        });
    }

    async add() {
        await this.editNoteModalRef.current.show({
            ...this.props
        });
        this.load();
    }

    async edit(id) {
        await this.editNoteModalRef.current.show({
            noteID: id
        });
        this.load();
    }

    async showAll() {
        await this.allNotesModalRef.current.show();
        this.load();
    }

    render() {
        const { isLoading, notes } = this.state;
        const { showNewestFirst, maxNum, allowShowAll, isReadOnly } = this.props;
        const loginInfo = GlobalStateService.getValue('loginInfo');
        const showFooter = (loginInfo.isAdmin || maxNum > 0);

        if (isLoading) {
            return (<Loader />);
        }
        
        return (<>

            <div className="sticky-table-container scrolling">
                <table className="table table-bordered sticky-table notes-table">
                    <thead>
                        <tr>
                            <th className="note-icons-col">&nbsp;</th>
                            <th className="date-col">Date</th>
                            {loginInfo.isAdmin &&
                                <th className="user-col">Added by</th>
                            }
                            <th className="text-col">Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {notes.map(n =>
                            <tr key={n.id} className={loginInfo.isAdmin && !isReadOnly ? 'selectable' : ''} onClick={() => loginInfo.isAdmin && !isReadOnly ? this.edit(n.id) : null}>
                                <td className="note-icons-col">
                                    {loginInfo.isAdmin && n.isVendorVisible && <span className="fa fa-eye" title="Visible to vendor" />}
                                    {n.isPinned && <span className="fa fa-thumbtack" title="Pinned" />}
                                </td>
                                <td className="date-col">
                                    {n.dateTime ? moment(n.dateTime).format('DD/MM/YYYY') : '—'}
                                </td>
                                {loginInfo.isAdmin &&
                                    <td className="user-col">
                                        {n.isSystemGenerated ? 'System' : n.user ? <>{n.user.firstName} {n.user.lastName}</> : '—'}
                                    </td>
                                }
                                <td className="text-col">
                                    <div>
                                        {TextHelpers.splitIntoLines(n.text, line => <div>{line}</div>)}
                                    </div>
                                </td>
                            </tr>
                        )}
                        {notes.length == 0 &&
                            <tr>
                                <td colSpan="4" className="empty-text">
                                    No notes yet
                                </td>
                            </tr>
                        }
                    </tbody>

                    {showFooter &&
                        <tfoot>
                            <tr>
                                <td colSpan="4">

                                    <div>

                                        {loginInfo.isAdmin &&
                                            <button type="button" className="btn btn-primary" onClick={() => this.add()}>
                                                <span className="fa fa-plus" />{' '}Add note
                                            </button>
                                        }

                                        {maxNum > 0 &&
                                            <div className="ms-auto">

                                                <span className="num-notes-message">
                                                    Showing {showNewestFirst ? `${maxNum} most recent ` : `first ${maxNum} `} note{maxNum == 1 ? '' : 's'}
                                                </span>

                                                {allowShowAll &&
                                                    <button type="button" className="btn btn-secondary ms-3" onClick={() => this.showAll()}>
                                                        Show all
                                                    </button>
                                                }

                                            </div>
                                        }

                                    </div>

                                </td>
                            </tr>
                        </tfoot>
                    }
                </table>
            </div>

            <EditNoteModal ref={this.editNoteModalRef} />
            {allowShowAll &&
                <AllNotesModal ref={this.allNotesModalRef} {...this.props} />
            }
        </>);
    }
}

export default NotesTable;
